import { useRootLoaderData } from '#app/root.js'

export function useFeatureFlag(featureFlag: string, defaultValue = false) {
	const { featureFlags } = useRootLoaderData()

	if (!featureFlags) return { isEnabled: defaultValue }
	if (!featureFlags[featureFlag]) return { isEnabled: defaultValue }

	return { isEnabled: featureFlags[featureFlag].isEnabled }
}
